// extracted by mini-css-extract-plugin
export default {"navigation":"mobile-bottom-navigation_navigation__-DZ1s","navigation__item":"mobile-bottom-navigation_navigation__item__2gTwU","active":"mobile-bottom-navigation_active__A1uHd"};